import strings from 'strings/strings.json';
import { useParams } from 'react-router-dom';
import useGetRequest from 'hooks/useGetRequest';
import { Course } from 'models/Course';
import CourseOverview from 'components/courseSchedule/CourseOverview';
import { styled } from 'styled-components';
import BlueHeader from 'components/sections/BlueHeader';
import NavBackButton from 'components/buttons/NavBackButton';
import FooterWhiteLogo from 'components/footer/FooterWhiteLogo';

export default function ViewPublishedCoursePage(): JSX.Element {
    const params = useParams();
    const { courseId } = params;

    const { data: course, loading } = useGetRequest<Course>(`courses/${courseId}`, !courseId);

    if (loading || !course) return <></>;

    return (
        <>
            <Wrapper>
                <BlueHeader
                    title={course.title}
                    logoS3Filepath={course.organisation.logoS3Filepath}
                    navBackButton={
                        <NavBackButton
                            backButtonTitle={strings.OACoursePage.backToDashboardButton.title}
                            backButtonAria={strings.OACoursePage.backToDashboardButton.aria}
                            backButtonHref="/organisation/dashboard"
                            backButtonNavigateState={{ state: { activeTabId: 'courses' } }}
                        />
                    }
                />
                <CourseOverview course={course} />
            </Wrapper>
            <FooterWhiteLogo />
        </>
    );
}

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(100vh - 184px);
`;
